// dynamic-checkbox-card.component.ts

import { FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomCheckBoxCardOption } from 'src/app/models/global-classes';
import { parseColor, ParsedColor } from '../../utils/ui/color-utils';

@Component({
  selector: 'app-dynamic-checkbox-card',
  templateUrl: './dynamic-checkbox-card.component.html',
  styleUrls: ['./dynamic-checkbox-card.component.css'],
})
export class DynamicCheckboxCardComponent implements OnInit {
  inputValue: any;
  @Input('inputValue') set setInputValue(inputValue: any) {
    this.inputValue = inputValue;
  }

  @Output() inputValueChange: EventEmitter<any> = new EventEmitter<any>();

  private _activeColorSet: string;
  activeColorSetParse: ParsedColor = parseColor('primary');

  @Input('activeColorSet') set setActiveColorSet(activeColorSet: string) {
    this._activeColorSet = activeColorSet;
    this.updateTheme();
  }

  private _option: CustomCheckBoxCardOption;
  @Input('option') set setOption(option: CustomCheckBoxCardOption) {
    this._option = option;
    this.updateTheme();
  }

  get option(): CustomCheckBoxCardOption {
    return this._option;
  }
  @Input() isActive: boolean;

  @Input() formControlInput: any = new FormControl();

  constructor() {}

  ngOnInit() {}

  private updateTheme() {
    // If activeColorSet is explicitly provided (even if it's 'primary'), it must win.
    // Otherwise, we fallback to the internal option.colorSet.
    const theme =
      this._activeColorSet !== undefined && this._activeColorSet !== null
        ? this._activeColorSet
        : this._option?.colorSet || 'primary';

    this.activeColorSetParse = parseColor(theme);
  }

  /**
   * Gets the complete set of classes for the card based on active state
   */
  getCardClasses(): string {
    if (this.isActive) {
      return `shadow-xl border-2 border-${this.activeColorSetParse.base}-500 ring-4 ring-${this.activeColorSetParse.base}-500/10 bg-${this.activeColorSetParse.base}-50/50`;
    }
    return `border-2 border-slate-200 bg-white hover:shadow-lg hover:border-${this.activeColorSetParse.base}-300 hover:bg-${this.activeColorSetParse.base}-50/30`;
  }

  /**
   * Gets the background class for the checkmark badge
   */
  getCheckmarkClass(): string {
    return `bg-${this.activeColorSetParse.base}-500`;
  }

  /**
   * Gets classes for the icon container
   */
  getIconContainerClasses(): string {
    if (this.isActive) {
      return `bg-${this.activeColorSetParse.base}-100 text-${this.activeColorSetParse.base}-600 scale-110`;
    }
    return `bg-gray-100 text-gray-600 group-hover:bg-${this.activeColorSetParse.base}-50 group-hover:text-${this.activeColorSetParse.base}-500 group-hover:scale-105`;
  }

  /**
   * Gets classes for the icon element
   */
  getIconClasses(): string {
    if (this.isActive) {
      return `text-${this.activeColorSetParse.base}-600`;
    }
    return `text-gray-600 group-hover:text-${this.activeColorSetParse.base}-500`;
  }

  /**
   * Gets classes for the title
   */
  getTitleClasses(): string {
    if (this.isActive) {
      return `text-${this.activeColorSetParse.base}-700`;
    }
    return `text-gray-900 group-hover:text-${this.activeColorSetParse.base}-600`;
  }

  /**
   * Gets class for gradient overlay
   */
  getGradientClass(): string {
    return `from-${this.activeColorSetParse.base}-500/10`;
  }
}
